import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatTableDataSource } from "@angular/material/table";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { MaskType } from "src/app/constants/masks";
import { TableColumnType } from "src/app/constants/table";
import { AgentsManageDisabled, AgentUser, AgentUserFilterPayload } from "src/app/models/agent";
import { Broker, WorkingBroker } from "src/app/models/broker";
import { TableColumn } from "src/app/models/table";

import { AgentService } from "src/app/services/agent.service";
import { MaskService } from "src/app/services/mask.service";
import { SessionService } from "src/app/services/storage/session.service";

@Component({
    selector: 'mwp-manage-agents',
    templateUrl: './agents.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AgentsComponent implements OnInit {
    public maskType = MaskType;
    public brokers: Broker[];
    public includeDisabled: boolean = false;
    public selectedAgentUser: AgentUser;
    public hasAccessToAllBrokers: boolean;

    public agentControlForm: FormGroup;
    public displayAgentForm: boolean;

    public agentForm: FormGroup;
    public agentFormArrayName: string = 'agentFormArrayName';
    public agentSelectedCheckboxName: string = 'agentSelectedCheckboxName';
    public agentMatTableData: MatTableDataSource<AgentUser>;
    public apiUrl = ContentHeaderKey.CounselorManageAgents;
    public agentColumns: TableColumn[] = [
        {
            columnName: 'User ID',
            propertyId: 'uid',
            columnType: TableColumnType.hyperLink,
            dataTypePropertyId: 'uid',
            isEmit: true,
        },
        {
            columnName: 'First Name',
            propertyId: 'firstName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Last Name',
            propertyId: 'lastName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Email',
            propertyId: 'email',
            columnType: TableColumnType.label
        },
        {
            columnName: 'Phone',
            propertyId: 'phone',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Disabled',
            propertyId: 'disabled',
            columnType: TableColumnType.checkBox,
        },
    ];

    constructor(
        private agentService: AgentService,
        private sessionService: SessionService,
        private formBuilder: FormBuilder,
        private maskService: MaskService,
    ) {
    }

    ngOnInit(): void {
        this.agentControlForm = this.formBuilder.group({
            brokerId: [this.sessionService.session.selectedBrokerId, Validators.required]
        });

        this.agentService.getBrokers().subscribe((response: Broker[]) => {
            this.brokers = response;
        });
        this.setBroker(this.sessionService.session.selectedBrokerId);
    }

    public setBroker(id: number): void {
        let l_WorkingBroker = new WorkingBroker();
        l_WorkingBroker.Id = id;

        this.agentService.setWorkingBroker(l_WorkingBroker).subscribe((response: Broker) => {
            this.hasAccessToAllBrokers = response.hasAccessToAllBrokers;
            this.buildAgent();
        });
    }

    private buildAgent(): void {
        let l_AgentFilterPayload = new AgentUserFilterPayload();
        l_AgentFilterPayload.includeDisabled = this.includeDisabled;

        this.agentService.getAgents(l_AgentFilterPayload).subscribe((response: AgentUser[]) => {
            response.forEach((r: AgentUser) => {
                r.phone = this.maskService.phoneFormatInbound(r.phone);
            });

            this.agentMatTableData = new MatTableDataSource<AgentUser>();
            this.agentMatTableData.data = response;

            let l_FormArray: FormArray = new FormArray([]);

            if (this.agentMatTableData.data != null || this.agentMatTableData.data.length > 0) {
                this.agentMatTableData.data.forEach((agentUser: AgentUser) => {
                    l_FormArray.push(
                        this.formBuilder.group({
                            firstName: [agentUser.firstName],
                            lastName: [agentUser.lastName],
                            uid: [agentUser.uid],
                            email: [agentUser.email],
                            disabled: [agentUser.disabled],
                            id: [agentUser.id],
                        })
                    );
                });
            }

            this.agentForm = this.formBuilder.group({
                [this.agentFormArrayName]: l_FormArray,
            });
        });
    }

    public brokerChange(event: number): void {
        this.setBroker(event);
    }

    public includeDisableChange(event: MatCheckboxChange): void {
        this.includeDisabled = event.checked;
        this.buildAgent();
    }

    public editAgent(agent: AgentUser): void {
        this.selectedAgentUser = agent;
        this.displayAgentForm = true;
    }

    public newAgent(): void {
        this.selectedAgentUser = new AgentUser();
        this.displayAgentForm = true;
    }

    public cancelEdit(): void {
        this.displayAgentForm = false;
        this.selectedAgentUser = null;
    }

    public saveAgentResponse(): void {
        this.displayAgentForm = false;
        this.selectedAgentUser = null;
        this.buildAgent();
    }

    public saveDisabledList(): void {
        const l_AgentsManageDisabled = new AgentsManageDisabled();
        const l_FormArray = this.agentForm.get(this.agentFormArrayName) as FormArray;

        l_FormArray.controls.map((afa) => {
            if (afa.get('disabled').value) {
                l_AgentsManageDisabled.disabled.push(afa.get('id').value);
            } else {
                l_AgentsManageDisabled.enabled.push(afa.get('id').value);
            }
        });

        this.agentService.updateDisabledAgents(l_AgentsManageDisabled).subscribe(() => {
            this.buildAgent();
        });
    }
}